export default "__VITE_ASSET__ChninCM1__"